import { Component } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { environment } from 'src/environments/environment';
import { ConfigDataService } from 'src/app/services/config-data.service';
declare function zE(arg1:string, arg2:string): void;
declare function zE(arg1:string, arg2:string, arg3:Function): void;

@Component({
    selector: 'app-login-chat-nav',
    templateUrl: './login-chat-nav.component.html',
    styleUrls: ['./login-chat-nav.component.scss'],
    standalone: false
})
export class LoginChatNavComponent {
     isChatOnline: boolean = false;
     userProfileData?: UserProfile;
     userName: string | null = null;
     areTermsAccepted: boolean = false;
     doRemount:boolean = false;
     isNavbarCollapsed: boolean = true;
     loginGovUrl: string = '';
     onSigninPage: boolean = false;
     showMVRByState: boolean = false;
     unreadIndicator: HTMLElement | null = null;
     conversationBadge: HTMLElement | null = null;
     

     constructor(public generalService:GeneralService, 
                 public authenticationService: AuthenticationService,
                 private router: Router,
                 private configDataService: ConfigDataService) { 
          this.areTermsAccepted = this.authenticationService.getHasAgreedToTerms();
          this.userName = this.authenticationService.getUserName();
          this.onSigninPage = this.router.url.includes('/signin');
     }

     ngOnInit(): void {
          this.configDataService.getConfig('showMVRByState').then((value: any) => {
               if (value && value.toString().toLowerCase() === 'true') {
                   this.showMVRByState = true;
               }else{
                    this.showMVRByState = false;
               }
           }).catch((error: any) => {
               console.error(error);
           });

           this.conversationBadge = document.getElementById('conversation-badge') as HTMLElement;
           this.unreadIndicator = document.getElementById('unread-indicator') as HTMLElement;
           // Close any open chats on init
           zE('messenger', 'close');
           // unread Message on listener
           // This is for sample functionality to show the number of unread messages.
           //       I'm leaving it in place in case we want to use it.
           zE('messenger:on', 'unreadMessages', (count:number) => {
               this.populateUnreadIndicator(count);
           })
     }

     ngAfterViewInit () {
          this.userProfileData = this.getUserProfile();
          this.areTermsAccepted = this.authenticationService.hasAgreedToTerms;
     }

     get route() {
          return this.router.url;
     }

     get userProfile() {
          this.userProfileData = this.authenticationService.getUserProfile();
          return this.userProfileData;
     }

     get hasAgreedToTerms() {
          return this.authenticationService.getHasAgreedToTerms();
     }

     get isAuthenticated(): boolean {
          const userName = this.authenticationService.getUserName();
          return (userName && userName.length > 0) ? true : false;
     }

     get isDriver() {
          return this.userProfile?.userData?.roles.includes('driver');
     }

     get isAccountHolder() {
          return this.userProfile?.userData?.roles.includes('mc_view');
     }

     get isCsr() {
          return this.userProfile?.userData?.roles.includes('csr_user');
     }

     get isIah() {
          return this.userProfile?.customerType === 2;
     }

     get isAdmin() {
          return this.userProfile?.userData?.roles.includes('mc_useradmin');
     }

     get showInvoices() {
          let showInvoices = false;

          if (this.isMonthlyAccountHolder(this.userProfile?.customerType)) {
              if (this.userProfile?.userData.email.toLowerCase() === this.userProfile?.customer.powerUserEmail?.toLowerCase()) {
                  showInvoices = true;
              } else if (this.userProfile?.userData.email.toLowerCase() === this.userProfile?.customer.billingInfo?.contactEmailId?.toLowerCase()) {
                  showInvoices = true;
              }
          }

          return showInvoices;
     }

     get firstName() {
          return this.userProfile?.firstName;
     }

     get lastName() {
          return this.userProfile?.lastName;
     }

     get customerId() {
          return this.userProfile?.customerId;
     }

     get customerType() {
          return this.userProfile?.customerType;
     }

     navigateToRecordChangeNotification() {
          this.router.navigate(['/monitoring']);
     }

     navigateToPaymentMethods() {
           this.router.navigate(['/payment']);
     }

     navigateToBillingReports() {
           this.router.navigate(['/billingReports']);
     }

     get csrDashboardUrl() {
          return `${environment.APP_PSP_NEXT_URL}csr/customers`;
     }

     navigateToDriverDashboard() {
          if (!this.router.url.includes('driverDashboard')) {
               this.router.navigate(['/driverDashboard']);
          }
     }

     navigateToAccountHolderDashboard() {
          this.router.navigate(['/dashboard']);
     }

     navigateToAuditDashboard() {
          this.router.navigate(['/auditDashboard']);
     }

     navigateToStateMVR() {
          this.router.navigate(['/MvrByState']);
     }

     navigateToUserAccountAdmin() {
          this.router.navigate(['/userAccountAdmin']);
     }

     navigateToUserWebServiceAccess() {
          this.router.navigate(['/wsAPI']);
     }

     navigateToUserWebServiceToken() {
          this.router.navigate(['/wsToken']);
     }

     navigateToInvoiceActivity() {
           this.router.navigate(['/invoice']);
     }

     logoff() {
          this.authenticationService.logout();
     }

     getUserProfile(): any {
          return this.authenticationService.getUserProfile();
     }

     isMonthlyAccountHolder(customerType: string|any) {
          let isMah = false;  
          // 1 = MC; 6 = ISP; 4 = TPIP; 5 = SuperTPIP;
          const mahCustomerTypes = [1,4,5,6];
          if (customerType && mahCustomerTypes.includes(customerType)) {
              isMah = true;
          }
          return isMah;
     }

     async redirectToLoginGov() {
          await this.generalService.getLoginGovUrl('').toPromise().then((response: string) => {
               this.loginGovUrl = response;
          });
          window.location.href = this.loginGovUrl;
     }

     populateUnreadIndicator(count:number) {
          if (!count) {
               return this.resetUnreadIndicator();
          }
          
          this.unreadIndicator!.style.background = '#CC3333'
          this.unreadIndicator!.innerHTML = count.toString();
          this.conversationBadge!.setAttribute('class', 'tilt-animation');
     }

     resetUnreadIndicator() {
          this.unreadIndicator!.style.background = 'black';
          this.unreadIndicator!.innerHTML = '0';
          this.conversationBadge!.setAttribute('class', '');
     }

     openZendeskChat(){
          // open widget
          zE('messenger', 'open');
          this.resetUnreadIndicator();
     }
}
